import axios from "axios";
import _ from "lodash";
import store from "../store/index";
import Vue from "vue";
import {
  getDevice
} from "@/config/utils.js";
import {
  goToWechatPage
} from "@/utils/index";
import {
  isTgjApp
} from "@/utils/nativeApi.js";
import appObj from '@/utils/tgjApp';
let device = getDevice();
let _this = new Vue();

const generateApiMap = map => {
  let facade = {};
  _.forEach(map, function (value, key) {
    facade[key] = toMethod(value);
  });
  return facade;
};

const toMethod = options => {
  options.method = options.method || "post";
  return (params = {}, attachedParams) => {

    // params = _.extend(params, attachedParams)
    let config = _.merge(options.config, attachedParams);
    return sendApiInstance(options.method, options.url, params, config);
  };
};

// 创建axios实例
const createApiInstance = (config = {}) => {
  let app_token = sessionStorage.getItem("app_token");
  const _config = {
    withCredentials: false, // 跨域
    baseURL: "",
    timeout: 10000,
    closeLoading: false,
    headers: {
      "User-Agent-System": device,
      // custId: '5d8046e39be92049fc6c981e',
      clientType: "tbwxmp",
      //   tenantId: "T0001",
      //   appCode: "pmcApp",
      //   appVersion: "v1.0.0",
      //   serviceType: "2",
      //unionId: "otCj7s1l0tDOXN5fnTZ7anlfM_Mk",
      // custId: "5fea919577d77a00254ced45"
      //unionId: "otCj7swVgG6TSMhLTmjLkhVQ4JQQ",
      // custId: "5ffbc80374c2980025ca1e79"
      //unionId: "otCj7s-7D7vsEo6lO4vr9NtkvzM0",
      //unionId: "otCj7s0MPaho7u3QP8juD3Qlgikw",
      //unionId: "otCj7s5uL5AL2uy5-BDztZoiPMw4",
      // unionId: "omKra1STqIia8Q2YiW2AdgO0RyO8",
      // unionId: "otCj7s2v4B89Nzr0Ir-3ER_SLzAU",
      // custId: '5e05d5070d3100002eb962f2'

      //我自己的信息 小白与重复预约
      // unionId: 'otCj7szitvVbUs96pgiy7lnICJBw',
      // custId: "5de9c79f2d4288002d4299c5"

      // // 有托管服务关系
      //unionId: 'otCj7s-ppVSYde0ertDWeKQTmhRw',
      //custId: "5dce14e72d4288002d8258ca"

      // //4 有交易的客户
      //unionId: 'otCj7syP7zrqdcDZvSXGyzbHsZTI',
      //custId: "608aa93de07c8b0025d32643"
      //3 有服务邀请的客户
      //unionId: 'otCj7swVgG6TSMhLTmjLkhVQ4JQQ',
      //custId: "61ef9f89990ce200251857ed",
      //unionId: 'otCj7s955Xqgi1cyno58RIiTpWKc',
      //unionId: 'otCj7s0MPaho7u3QP8juD3Qlgikw'
    }
  };
  if (config.url.indexOf('ccs') != -1 || config.url.indexOf('pmc') != -1) {
    _config.headers['tenantId'] = "T0001"
    _config.headers['appCode'] = "pmcApp"
    _config.headers['appVersion'] = "v1.0.0"
    _config.headers['serviceType'] = "2"
    let fromId = sessionStorage.getItem("fromId");
    if (fromId) {
      _config.headers['fromId'] = fromId
    }
  }
  if (app_token) {
    _config.headers["Authorization"] = app_token;
  }
  config = _.merge(_config, config);
  return axios.create(config);
};

const err_check = (status, message, data) => {
  if (status == 1 || status == 6666) {
    return true;
  }
  return false;
};

const sendApiInstance = (method, url, params, config = {}) => {
  if (!url) {
    return;
  }
  if (!config.closeLoading) {
    _this.$showLoading();
    store.commit("showMaskView");
  }
  config.url = url;
  let instance = createApiInstance(config);
  instance.interceptors.response.use(
    async response => {
        if (!config.closeLoading) {
          if (!config.hideMaskView) {
            _this.$hideLoading();
            store.commit("hideMaskView");
          }
        }
        let {
          status,
          msg,
          data,
          page,
          resp_code,
          resp_msg,
          datas
        } = response.data;
        if (config.url.indexOf('ccs') != -1 || config.url.indexOf('pmc') != -1 || resp_code == 0 ) {
          if (resp_code == 0) {
            return {
              data: datas,
              msg: resp_msg,
              status: 1,
            };
          } else if (resp_code == 401) {
            let nextPage = sessionStorage.getItem("nextPage");
            if (nextPage) {
              // 错误处理
              return {
                data: null,
                msg: resp_msg || "服务异常!",
                status: 0,
              };
            } else if (!config.noRedirect) {
              // 重登录
              if (isTgjApp()) {
                appObj.loadingPageFinish(['2'])
                appObj.backAction()
              } else {
                sessionStorage.setItem("app_token", "");
                sessionStorage.setItem("wechatToken", "");
                let targetUrl = window.location.href;
                location.replace(goToWechatPage(targetUrl));
              }
            }
          } else {
            // 错误处理
            return {
              data: null,
              msg: resp_msg || "服务异常!",
              status: 0,
            };
          }
        } else if (err_check(status, msg, data) && data) {
          return {
            data: data,
            msg: null,
            status: status,
            page: page
          };
        } else {
          //401 token过期
          let nextPage = sessionStorage.getItem("nextPage");
          if (nextPage) {
            // 错误处理
            return {
              data: null,
              msg: resp_msg || "服务异常!",
              status: 0,
            };
          } else if (status == 401) {
            //跳转登陆
            if (!config.noRedirect) {
              // 重登录
              if (isTgjApp()) {
                appObj.loadingPageFinish(['2'])
                appObj.backAction()
              } else {
                sessionStorage.setItem("app_token", "");
                sessionStorage.setItem("wechatToken", "");
                let targetUrl = window.location.href;
                location.replace(goToWechatPage(targetUrl));
              }
            }
          } else {
            // 错误处理
            return {
              data: null,
              msg: msg || "服务异常!",
              status: status,
              error: response.data.error,
              page: page
            };
          }
        }
      },
      error => {
        console.log("服务异常!");
        if (!config.closeLoading) {
          _this.$hideLoading();
          store.commit("hideMaskView");
        }
        if (config.showError) {
          store.commit("setErrorTips", true);
        }
      }
  );
  if (method === "get") {
    params = {
      params: params
    };
  }
  if (method === "delete") {
    params = {
      data: params,
      params: params
    };
  }


  return instance[method](url, params, config);
};

export default {
  generateApiMap
};



// WEBPACK FOOTER //
// ./src/api/apiUtil.js